module.exports = __webpack_public_path__ + "img/pro_eight_4.614e2b19.jpg";